import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth/auth.guard';
import { AutoLoginGuard } from '@core/guards/auto-login/auto-login.guard';
import { SchedulerAuthGuard } from '@core/guards/scheduler-auth/scheduler-auth.guard';

const routes: Routes = [
    {
        canActivate: [AutoLoginGuard],
        path: 'login',
        loadChildren: () => import('./login/login.routes').then(m => m.LOGIN_ROUTES)
    },
    {
        canActivate: [AuthGuard],
        path: 'agenda',
        loadChildren: () => import('./agenda/agenda.routes').then(m => m.AGENDA_ROUTES)
    },
    {
        canActivate: [AuthGuard],
        path: 'appointment-wizard',
        loadChildren: () => import('./appointment-wizard/appointment-wizard.routes').then(m => m.APPOINTMENT_WIZARD_ROUTES)
    },
    {
        canActivate: [AuthGuard],
        path: 'clients',
        loadChildren: () => import('./clients/clients.routes').then( m => m.CLIENTS_ROUTES),
    },
    {
        // Modo Agendador de Call Center: me.flowww.net/scheduler/{ID_CLIENTE}
        canActivate: [SchedulerAuthGuard],
        path: 'scheduler/:hubspotClientId',
        loadChildren: () => import('./scheduler/scheduler.routes').then(m => m.SCHEDULER_ROUTES)
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
